import React, { useEffect } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { Title } from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";
import OverviewTab from "./tabs/OverviewTab";
import QuestionsTab from "./tabs/QuestionsTab";
import UnitProgressTab from "./tabs/UnitProgressTab";
import EngagementTab from "./tabs/EngagementTab";

const TAB_NAMES = [
  "overview",
  "questions",
  "unit-progress",
  "engagement",
] as const;

export const LearningDashboard: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const segment = location.pathname.split("/learning/")[1] || "";
  const activeTab = Math.max(
    0,
    TAB_NAMES.indexOf(segment as (typeof TAB_NAMES)[number])
  );

  useEffect(() => {
    if (
      !segment ||
      !TAB_NAMES.includes(segment as (typeof TAB_NAMES)[number])
    ) {
      navigate("/learning/overview", { replace: true });
    }
  }, [segment, navigate]);

  return (
    <Box sx={{ p: 2, maxWidth: 1600 }}>
      <Title title="Learning Metrics" />
      <Typography variant="h5" sx={{ mb: 2 }}>
        Learning Dashboard
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, v: number) => navigate(`/learning/${TAB_NAMES[v]}`)}
        sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Overview" />
        <Tab label="Questions" />
        <Tab label="Unit Progress" />
        <Tab label="Engagement" />
      </Tabs>

      {activeTab === 0 && <OverviewTab />}
      {activeTab === 1 && <QuestionsTab />}
      {activeTab === 2 && <UnitProgressTab />}
      {activeTab === 3 && <EngagementTab />}
    </Box>
  );
};
